import React from "react";
import "./UnitsSettingsStyle.css";
import { AiFillDelete } from "react-icons/ai";
import { UnitModel} from "../../model/UnitsModel";

interface State {
  searchTerm: string;
  filteredCars: UnitModel[];
}

interface Actions {
  setSearchTerm: (term: string) => void;
  updateLocalName: (id: number, field: string, value: string) => void;
  handleNameChange: (unitID: string, value: string) => void;
  deleteCar: (id: number) => void;
  addCar: () => void;
  onBackClick: () => void;
}

interface Props {
  loggedState: number;
  state: State;
  actions: Actions;
}

const UnitsSettingsView: React.FC<Props> = ({ loggedState, state, actions }) => {
  return (
    <div
      className="App"
      style={{ visibility: loggedState === 0 ? "hidden" : "visible" }}
    >
      <div className="search-box-container">
        <div className="header">
          <h2>Einheiten-Verwaltung</h2>
          <button className="new-button" onClick={actions.addCar}>
            Neue Einheit
          </button>
        </div>
        <div className="search-box">
          <label htmlFor="search">Suche:</label>
          <input
            type="text"
            id="search"
            value={state.searchTerm}
            onChange={(e) => actions.setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <table className="table">
        <thead className="table-header">
          <tr>
            <th className="col-1">Einheit</th>
            <th className="col-2"></th>
          </tr>
        </thead>
        <tbody>
          {state.filteredCars.map((row) => (
            <tr key={row.ID}>
              <td className="col-1">
                <input
                  type="text"
                  value={row.Unit}
                  onChange={(e) =>
                    actions.updateLocalName(row.ID, "Unit", e.target.value)
                  }
                  onBlur={(e) =>
                    actions.handleNameChange(String(row.ID), String(e.target.value))
                  }
                />
              </td>
              <td className="col-2">
                <span className="icon" onClick={() => actions.deleteCar(row.ID)}>
                  <AiFillDelete />
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UnitsSettingsView;